module.exports = __webpack_public_path__ + "static/media/path.baf83b2e.svg";